import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { AdminService } from '../../../services/admin.service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {Profile} from '../../../Models/profile';
import {ProfileModalComponent} from './profile-modal.component';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';

@Component({
  selector: 'app-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.css']
})

export class ProfileListComponent implements OnInit {

  profileList: Profile[];
  profileModal: any = ProfileModalComponent;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  errorMessage = '';

  constructor(private admService: AdminService, private modalService: GenericModalService, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.admService.loadProfiles()
      .subscribe(result => this.profileList = result, error => this.errorMessage = error);
  }

  onAddProfile() {
    const result$ = this.modalService.showXlModal(this.profileModal, 'Novo Perfil', 0, 'modal-profile');
    if (result$) {
      result$.asObservable()
        .pipe()
        .subscribe(result => {
            this.ngOnInit();
          }
        );
    }
  }

  onEdit(profileId: number) {
    const result$ = this.modalService.showXlModal(this.profileModal, 'Editar Perfil', profileId,'modal-profile');
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          this.ngOnInit();
        }
      );
  }
}
